
import { defineComponent } from "vue";
import ButtonRequest from "../Generics/ButtonRequest.vue";

export default defineComponent({
  components: { ButtonRequest },
  name: "ClubModal",
  data() {
    return {
      inputValue: 25 as number,
      coinsValue: 2.5 as number,
    };
  },
  methods: {
    updateRangeValue(event: Event) {
      if (event.target) {
        this.inputValue = parseInt((event.target as HTMLInputElement).value);
        this.coinsValue = this.inputValue / 10;
      }
    },
  },
});
